A page of events from a stream.
